import React from 'react';

const ChevronUp = ({ width = 44, height = 44, color = '#616161', ...rest }) => {
  return (
    <svg {...rest} height={height} width={width} fill="none" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.0139 26.6832C30.5509 26.1462 30.5509 25.2756 30.0139 24.7387L22.6805 17.4054C22.1436 16.8684 21.2731 16.8684 20.7361 17.4054L13.4027 24.7387C12.8658 25.2756 12.8658 26.1462 13.4027 26.6832C13.9397 27.2202 14.8103 27.2202 15.3473 26.6832L21.7083 20.3222L28.0694 26.6832C28.6064 27.2202 29.4769 27.2202 30.0139 26.6832Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default ChevronUp;
